import { EditorCore } from "./templates-editor";
import { ReturnTemplatesProvider } from "./return-provider";

export type ReturnTemplatesEditorProps = {
  /** Current shop id (provided by the host app's router). */
  shopId: string;
  /** Template currently being edited. */
  currentTemplateId: string;
  /** Navigate to another template's editor (host-provided). */
  openTemplate?: (templateId: string) => void;
  devMode?: boolean;
  localEmailsTestingUrl?: string;
  openThemeSettings?: () => void;
  currentUserEmail?: string;
};

/**
 * Return templates editor — used by baback-office.
 *
 * Router-agnostic: the host passes `shopId` and navigation callbacks as props
 * (baback-office wires them with react-router-dom), so this package never
 * imports a router for the return path. Unsaved-changes protection is limited
 * to the browser-level `beforeunload` handled by the core (baback-office runs on
 * a declarative <BrowserRouter>, which cannot block internal navigation).
 */
export default function ReturnTemplatesEditor(props: ReturnTemplatesEditorProps) {
  return (
    <ReturnTemplatesProvider
      shopId={props.shopId}
      openTemplate={props.openTemplate}
    >
      <EditorCore
        currentTemplateId={props.currentTemplateId}
        devMode={props.devMode}
        localEmailsTestingUrl={props.localEmailsTestingUrl}
        openThemeSettings={props.openThemeSettings}
        currentUserEmail={props.currentUserEmail}
      />
    </ReturnTemplatesProvider>
  );
}
